var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.535,
    height: 16.536,
    viewBox: "0 0 16.535 16.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622",
    transform: "translate(20960.27 10075.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7962",
    "data-name": "Path 7962",
    d: "M10.67,15.5a.688.688,0,0,0,.276-.565.77.77,0,0,0-.863-.754.846.846,0,0,0-.928.78l-.009.13h.54l.014-.105a.331.331,0,0,1,.373-.3c.123,0,.331.036.331.276,0,.087,0,.29-.511.294h-.2v.5h.2c.494,0,.562.172.562.357,0,.209-.13.324-.365.324a.391.391,0,0,1-.427-.356l-.012-.107H9.108l.011.131a.887.887,0,0,0,.971.836.8.8,0,0,0,.9-.8.727.727,0,0,0-.321-.645",
    transform: "translate(-20964.953 -10083.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7963",
    "data-name": "Path 7963",
    d: "M14.411,14.171c-.453,0-.992.238-.992,1.37,0,.647.117,1.39,1.023,1.39a.872.872,0,0,0,.924-.937.859.859,0,0,0-.89-.941.937.937,0,0,0-.526.153.741.741,0,0,1,.166-.43.384.384,0,0,1,.292-.1.307.307,0,0,1,.347.28l.019.1H15.3l-.017-.136a.813.813,0,0,0-.869-.743M14.824,16a.38.38,0,0,1-.4.426.421.421,0,0,1-.457-.46.4.4,0,0,1,.443-.413c.274,0,.413.151.413.447",
    transform: "translate(-20967.172 -10083.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7964",
    "data-name": "Path 7964",
    d: "M18.766,16.939c.975,0,.975-1.036.975-1.376s0-1.363-.975-1.363-.979,1.026-.979,1.363,0,1.376.979,1.376m-.43-1.376c0-.619.112-.838.43-.838s.426.22.426.838-.111.851-.426.851-.43-.223-.43-.851",
    transform: "translate(-20969.418 -10083.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7965",
    "data-name": "Path 7965",
    d: "M22.662,15.884a.72.72,0,1,0-.717-.723.694.694,0,0,0,.717.723m0-.43c-.143,0-.225-.107-.225-.293s.087-.294.229-.294.232.112.232.294-.09.293-.236.293",
    transform: "translate(-20971.557 -10083.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7966",
    "data-name": "Path 7966",
    d: "M8.268,0a8.268,8.268,0,1,0,8.268,8.268A8.277,8.277,0,0,0,8.268,0m4.276,8.268a12.178,12.178,0,0,1-.56,3.716,12.175,12.175,0,0,1-3.716.56,12.175,12.175,0,0,1-3.716-.56,12.178,12.178,0,0,1-.56-3.716,12.175,12.175,0,0,1,.56-3.716,12.175,12.175,0,0,1,3.716-.56,12.175,12.175,0,0,1,3.716.56,12.175,12.175,0,0,1,.56,3.716m-.877-4.557a13.137,13.137,0,0,0-6.8,0C5.651,1.9,6.882.728,8.268.728s2.617,1.174,3.4,2.983M3.711,4.869a13.135,13.135,0,0,0,0,6.8C1.9,10.885.728,9.654.728,8.268S1.9,5.651,3.711,4.869m1.158,7.955a13.123,13.123,0,0,0,6.8,0c-.782,1.809-2.013,2.984-3.4,2.984s-2.617-1.175-3.4-2.984m7.956-1.157a13.137,13.137,0,0,0,0-6.8c1.809.782,2.983,2.013,2.983,3.4s-1.174,2.617-2.983,3.4M3.993,3.993a7.694,7.694,0,0,0-2.8,1.7A7.564,7.564,0,0,1,5.7,1.19a7.687,7.687,0,0,0-1.7,2.8m0,8.55a7.687,7.687,0,0,0,1.7,2.8A7.565,7.565,0,0,1,1.19,10.841a7.694,7.694,0,0,0,2.8,1.7m8.55,0a7.694,7.694,0,0,0,2.8-1.7,7.564,7.564,0,0,1-4.505,4.505,7.694,7.694,0,0,0,1.7-2.8m0-8.55a7.694,7.694,0,0,0-1.7-2.8A7.563,7.563,0,0,1,15.346,5.7a7.694,7.694,0,0,0-2.8-1.7",
    transform: "translate(-20960.27 -10075.896)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.fd6d5f75bba5fda8cb217377660cf033.svg";
export { ForwardRef as ReactComponent };